import { render } from "./FrivilligeShopWrongRoleModal.vue?vue&type=template&id=c7023198"
import script from "./FrivilligeShopWrongRoleModal.vue?vue&type=script&lang=js"
export * from "./FrivilligeShopWrongRoleModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__